<template>
  <div class="add-crew-popup">
    <h4 class="title">
      {{ ptitle }}
    </h4>

    <b-form-input
      v-model="newCrew.nickname"
      placeholder="Enter Full Name"
    ></b-form-input>
    <b-form-input
      v-model="newCrew.email"
      type="email"
      placeholder="Email for Lookup"
    ></b-form-input>
    <b-form-input
      v-model="newCrew.role"
      placeholder="Role (e.g. Trainer, Doctor)"
    ></b-form-input>
    <button
      v-if="ptitle == 'Add Crew'"
      class="btn btn-primary btn-sm collapsed"
      @click="addCrew"
    >
      Add Crew
    </button>
    <button v-else class="btn btn-primary btn-sm collapsed" @click="addCrew">
      Edit Crew
    </button>
  </div>
</template>

<script>
export default {
  props: {
    ptitle: String,
    nickname: String,
    email: String,
    role: String,
    index: Number
  },
  data() {
    return {
      newCrew: {
        nickname: this.nickname || "",
        email: this.email || "",
        role: this.role || "",
        index: this.index
      }
    };
  },
  methods: {
    addCrew() {
      this.$emit("addCrew", this.newCrew);
    }
  }
};
</script>

<style lang="scss" scoped>
.add-crew-popup {
  .form-control {
    height: 47px;
  }
  :-ms-input-placeholder,
  ::placeholder,
  ::-webkit-input-placeholder {
    /* Edge */
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 22px;
    // color: #8d99a0;
    color: red;
  }
}
.btn.collapsed {
  padding: 11px;
  width: 100%;
  height: 48px;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  color: #ffffff;
  border-radius: 8px;
  margin-top: 23px;
}
</style>
